import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { I18nProvider } from "./context/I18nContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import BrandPage from "./pages/BrandPage";
import Insights from "./pages/Insights";
import InsightDetail from "./pages/InsightDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import RegisterCompany from "./pages/RegisterCompany";
import ForgotPassword from "./pages/ForgotPassword";
import ForgotUsername from "./pages/ForgotUsername";
import ResetPassword from "./pages/ResetPassword";
import SharePage from "./pages/SharePage";
import PublicQuoteApproval from "./pages/PublicQuoteApproval";
import PublicPO from "./pages/PublicPO";
import Terminos from "./pages/Terminos";
import Privacidad from "./pages/Privacidad";
import GoutReady from "./pages/GoutReady";
import CookieBanner from "./components/site/CookieBanner";
import { useEffect } from "react";
import { trackPageview } from "./lib/analytics";
import Hub from "./pages/os/Hub";
import Intelligence from "./pages/os/Intelligence";
import Assistant from "./pages/os/Assistant";
import Chat from "./pages/os/Chat";
import GoutStudio from "./pages/os/GoutStudio";
import OmniaFlow from "./pages/os/OmniaFlow";
import OmniaFlowProject from "./pages/os/OmniaFlowProject";
import StudioProject from "./pages/os/StudioProject";
import InteriorCalculator from "./pages/os/InteriorCalculator";import AuraCommerce from "./pages/os/AuraCommerce";
import AuraProduct from "./pages/os/AuraProduct";
import VettaFactory from "./pages/os/VettaFactory";
import VettaProject from "./pages/os/VettaProject";
import AuraProject from "./pages/os/AuraProject";
import TagmaStudio from "./pages/os/TagmaStudio";
import Crm from "./pages/os/Crm";
import Finance from "./pages/os/Finance";
import Contabilidad from "./pages/os/Contabilidad";
import Calendario from "./pages/os/Calendario";
import Operaciones from "./pages/os/Operaciones";
import OperacionProject from "./pages/os/OperacionProject";
import MasterMetrics from "./pages/os/MasterMetrics";
import Automation from "./pages/os/Automation";
import AdminUsers from "./pages/os/AdminUsers";
import Bitacora from "./pages/os/Bitacora";
import StyleGuide from "./pages/os/StyleGuide";
import Workflows from "./pages/os/Workflows";
import Copiloto from "./pages/os/Copiloto";
import Administracion from "./pages/os/Administracion";
import Marketplace from "./pages/os/Marketplace";
import Extensiones from "./pages/os/Extensiones";
import Integraciones from "./pages/os/Integraciones";
import Plataforma from "./pages/os/Plataforma";
import Social from "./pages/os/Social";
import Announcements from "./pages/os/Announcements";
import Onboarding from "./pages/os/Onboarding";
import CareerPaths from "./pages/os/CareerPaths";
import Skills from "./pages/os/Skills";import Sign from "./pages/os/Sign";
import Recruiting from "./pages/os/Recruiting";
import Approvals from "./pages/os/Approvals";
import NineBox from "./pages/os/NineBox";
import EmployeeServices from "./pages/os/EmployeeServices";
import WorkspaceTools from "./pages/os/WorkspaceTools";
import InternalComms from "./pages/os/InternalComms";
import Positions from "./pages/os/Positions";
import WorkforcePlanning from "./pages/os/WorkforcePlanning";
import WorkforceHub from "./pages/os/WorkforceHub";
import LeadershipDev from "./pages/os/LeadershipDev";
import WellPrograms from "./pages/os/WellPrograms";
import Polls from "./pages/os/Polls";
import TimeTracker from "./pages/os/TimeTracker";
import WellbeingAI from "./pages/os/WellbeingAI";
import PersonalDashboard from "./pages/os/PersonalDashboard";
import Directory from "./pages/os/Directory";
import MyProfile from "./pages/os/MyProfile";
import SheetsHub from "./pages/os/SheetsHub";
import TicketsControl from "./pages/os/TicketsControl";
import Correctivos from "./pages/os/Correctivos";
import Fleet from "./pages/os/Fleet";
import Planning from "./pages/os/Planning";
import PlanDetail from "./pages/os/planning/PlanDetail";
import Cuadrillas from "./pages/os/Cuadrillas";
import GestionTalento from "./pages/os/GestionTalento";
import LeaderPanel from "./pages/os/LeaderPanel";
import PeopleIntelligence from "./pages/os/PeopleIntelligence";
import PeopleActions from "./pages/os/PeopleActions";
import MasterRecord from "./pages/os/MasterRecord";
import SocialConnect from "./pages/os/SocialConnect";
import OAuthCallback from "./pages/os/OAuthCallback";
import GrUnits from "./pages/os/GrUnits";
import GrFloorPlans from "./pages/os/GrFloorPlans";
import GrMortgage from "./pages/os/GrMortgage";
import Gr3DTours from "./pages/os/Gr3DTours";
import GrStaging from "./pages/os/GrStaging";
import GrShowroom from "./pages/os/GrShowroom";
import GrConfigurator from "./pages/os/GrConfigurator";
import GrArViewer from "./pages/os/GrArViewer";
import GrSalesPresentation from "./pages/os/GrSalesPresentation";
import GrClosingRoom from "./pages/os/GrClosingRoom";
import ModulePage from "./pages/os/ModulePage";
import AgentSetup from "./pages/os/AgentSetup";
import Personas from "./pages/os/Personas";
import CoreHR from "./pages/os/CoreHR";
import TalentStudio from "./pages/os/TalentStudio";
import PerformanceStudio from "./pages/os/PerformanceStudio";
import LearningStudio from "./pages/os/LearningStudio";
import WorkforceStudio from "./pages/os/WorkforceStudio";
import PayrollStudio from "./pages/os/PayrollStudio";
import WellnessStudio from "./pages/os/WellnessStudio";
import AppWorkspace from "./pages/os/AppWorkspace";
import StudioDashboard from "./pages/os/StudioDashboard";
import ExecutiveDashboard from "./pages/os/ExecutiveDashboard";
import ShopOrders from "./pages/os/ShopOrders";
import Academy from "./pages/os/Academy";
import CourseDetail from "./pages/os/CourseDetail";
import AcademyDashboard from "./pages/os/AcademyDashboard";
import ContentAuthoring from "./pages/os/ContentAuthoring";
import GamePlayer from "./pages/os/GamePlayer";
import AuthoredCourse from "./pages/os/AuthoredCourse";
import Treasury from "./pages/os/Treasury";
import OracleHub from "./pages/os/OracleHub";
import OmniaAnalytics from "./pages/os/OmniaAnalytics";
import Microsoft365 from "./pages/os/Microsoft365";
import Facturacion from "./pages/os/Facturacion";
import OmniaChat from "./pages/os/OmniaChat";
import { CartProvider } from "./context/CartContext";
import { BrandingProvider } from "./context/BrandingContext";
import Shop from "./pages/shop/Shop";
import ShopProduct from "./pages/shop/ShopProduct";
import Cart from "./pages/shop/Cart";
import ShopSuccess from "./pages/shop/ShopSuccess";
import ShopTrack from "./pages/shop/ShopTrack";
import { canAccess } from "./lib/permissions";

function Protected({ children, allowUser }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <span className="font-sans tracking-[0.3em] text-navy/40 animate-pulse">OMNIA</span>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/os" replace />;
  return children;
}

function Gated({ module, children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <span className="font-sans tracking-[0.3em] text-navy/40 animate-pulse">OMNIA</span>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (!canAccess(user.role, module)) return <Navigate to="/os" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/os" replace />;
  return children;
}

function CatchAll() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={user ? "/os" : "/"} replace />;
}

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => { trackPageview(); }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <I18nProvider>
      <ThemeProvider>
      <AuthProvider>
        <BrandingProvider>
        <CartProvider>
        <BrowserRouter>
          <Toaster position="top-center" />
          <AnalyticsTracker />
          <CookieBanner />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/marca/:key" element={<BrandPage />} />
            <Route path="/terminos" element={<Terminos />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/gout-ready" element={<GoutReady />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<InsightDetail />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/product/:id" element={<ShopProduct />} />
            <Route path="/shop/cart" element={<Cart />} />
            <Route path="/shop/success" element={<ShopSuccess />} />
            <Route path="/shop/track" element={<ShopTrack />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/register-company" element={<PublicOnly><RegisterCompany /></PublicOnly>} />
            <Route path="/forgot-password" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
            <Route path="/forgot-username" element={<PublicOnly><ForgotUsername /></PublicOnly>} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/share/:token" element={<SharePage />} />
            <Route path="/aprobar/:token" element={<PublicQuoteApproval />} />
            <Route path="/cotizacion/:token" element={<PublicQuoteApproval apiBase="/studio/public/quote" />} />
            <Route path="/oc/:token" element={<PublicPO />} />
            <Route path="/os/omnia" element={<Protected allowUser><OmniaChat /></Protected>} />
            <Route path="/os" element={<Protected><Hub /></Protected>} />
            <Route path="/os/tagma" element={<Protected><TagmaStudio /></Protected>} />
            <Route path="/os/tagma/:id" element={<Protected><StudioProject /></Protected>} />
            <Route path="/os/flow" element={<Protected><OmniaFlow /></Protected>} />
            <Route path="/os/flow/:id" element={<Protected><OmniaFlowProject /></Protected>} />
            <Route path="/os/gout" element={<Gated module="gout"><GoutStudio /></Gated>} />
            <Route path="/os/gout-calculadora" element={<Gated module="gout"><InteriorCalculator /></Gated>} />
            <Route path="/os/gout/:id" element={<Gated module="gout"><StudioProject /></Gated>} />
            <Route path="/os/aura" element={<Gated module="aura"><AuraCommerce /></Gated>} />
            <Route path="/os/sheets" element={<Protected><SheetsHub /></Protected>} />
            <Route path="/os/control-tickets" element={<Protected><TicketsControl /></Protected>} />
            <Route path="/os/correctivos" element={<Protected><Correctivos /></Protected>} />
            <Route path="/os/flotilla" element={<Protected><Fleet /></Protected>} />
            <Route path="/os/cuadrillas" element={<Protected><Cuadrillas /></Protected>} />
            <Route path="/os/planning" element={<Protected><Planning /></Protected>} />
            <Route path="/os/planning/:id" element={<Protected><PlanDetail /></Protected>} />
            <Route path="/os/aura/proyecto/:gid" element={<Protected><AuraProject /></Protected>} />
            <Route path="/os/aura/:id" element={<Gated module="aura"><AuraProduct /></Gated>} />
            <Route path="/os/vetta" element={<Gated module="vetta"><VettaFactory /></Gated>} />
            <Route path="/os/vetta/proyecto/:gid" element={<Protected><VettaProject /></Protected>} />
            <Route path="/os/shop-orders" element={<Gated module="shop-orders"><ShopOrders /></Gated>} />
            <Route path="/os/crm" element={<Gated module="crm"><Crm /></Gated>} />
            <Route path="/os/finance" element={<Gated module="finance"><Finance /></Gated>} />
            <Route path="/os/contabilidad" element={<Gated module="contabilidad"><Contabilidad /></Gated>} />
            <Route path="/os/calendario" element={<Protected><Calendario /></Protected>} />
            <Route path="/os/personas" element={<Protected><Personas /></Protected>} />
            <Route path="/os/directory" element={<Protected><Directory /></Protected>} />
            <Route path="/os/directorio" element={<Protected><Directory /></Protected>} />
            <Route path="/os/mi-perfil" element={<Protected><MasterRecord /></Protected>} />
            <Route path="/os/user" element={<Protected><MasterRecord /></Protected>} />
            <Route path="/os/gestion-talento" element={<Protected><GestionTalento /></Protected>} />
            <Route path="/os/lider" element={<Protected><LeaderPanel /></Protected>} />
            <Route path="/os/expediente" element={<Protected><MasterRecord /></Protected>} />
            <Route path="/os/expediente/:uid" element={<Protected><MasterRecord /></Protected>} />
            <Route path="/os/people-intelligence" element={<Protected><PeopleIntelligence /></Protected>} />
            <Route path="/os/people-actions" element={<Protected><PeopleActions /></Protected>} />
            <Route path="/os/core-hr" element={<Protected><CoreHR /></Protected>} />
            <Route path="/os/talent" element={<Protected><TalentStudio /></Protected>} />
            <Route path="/os/performance" element={<Protected><PerformanceStudio /></Protected>} />
            <Route path="/os/learning" element={<Protected><LearningStudio /></Protected>} />
            <Route path="/os/workforce" element={<Protected><WorkforceStudio /></Protected>} />
            <Route path="/os/payroll" element={<Protected><PayrollStudio /></Protected>} />
            <Route path="/os/wellness" element={<Protected><WellnessStudio /></Protected>} />
            <Route path="/os/social" element={<Protected><Social /></Protected>} />
            <Route path="/os/announcements" element={<Protected><Announcements /></Protected>} />
            <Route path="/os/onboarding" element={<Protected><Onboarding /></Protected>} />
            <Route path="/os/career-paths" element={<Protected><CareerPaths /></Protected>} />
            <Route path="/os/skills" element={<Protected><Skills /></Protected>} />
            <Route path="/os/sign" element={<Protected><Sign /></Protected>} />
            <Route path="/os/reclutamiento" element={<Protected><Recruiting /></Protected>} />
            <Route path="/os/aprobaciones" element={<Protected><Approvals /></Protected>} />
            <Route path="/os/nine-box" element={<Protected><NineBox /></Protected>} />
            <Route path="/os/servicios" element={<Protected><EmployeeServices /></Protected>} />
            <Route path="/os/herramientas" element={<Protected><WorkspaceTools /></Protected>} />
            <Route path="/os/comunicacion" element={<Protected><InternalComms /></Protected>} />
            <Route path="/os/plantilla" element={<Protected><WorkforceHub /></Protected>} />
            <Route path="/os/workforce-planning" element={<Protected><WorkforceHub /></Protected>} />
            <Route path="/os/leadership" element={<Protected><LeadershipDev /></Protected>} />
            <Route path="/os/well-programs" element={<Protected><WellPrograms /></Protected>} />
            <Route path="/os/polls" element={<Protected><Polls /></Protected>} />
            <Route path="/os/tiempo" element={<Protected><TimeTracker /></Protected>} />
            <Route path="/os/bienestar" element={<Protected><WellbeingAI /></Protected>} />
            <Route path="/os/mi-panel" element={<Protected><PersonalDashboard /></Protected>} />
            <Route path="/os/social-connect" element={<Protected><SocialConnect /></Protected>} />
            <Route path="/oauth/:provider/callback" element={<Protected><OAuthCallback /></Protected>} />
            <Route path="/os/gr/units" element={<Protected><GrUnits /></Protected>} />
            <Route path="/os/gr/floor-plans" element={<Protected><GrFloorPlans /></Protected>} />
            <Route path="/os/gr/mortgage" element={<Protected><GrMortgage /></Protected>} />
            <Route path="/os/gr/tours" element={<Protected><Gr3DTours /></Protected>} />
            <Route path="/os/gr/staging" element={<Protected><GrStaging /></Protected>} />
            <Route path="/os/gr/showroom" element={<Protected><GrShowroom /></Protected>} />
            <Route path="/os/gr/configurator" element={<Protected><GrConfigurator /></Protected>} />
            <Route path="/os/gr/ar" element={<Protected><GrArViewer /></Protected>} />
            <Route path="/os/gr/presentation" element={<Protected><GrSalesPresentation /></Protected>} />
            <Route path="/os/gr/closing" element={<Protected><GrClosingRoom /></Protected>} />
            <Route path="/os/mod/:key" element={<Protected><ModulePage /></Protected>} />
            <Route path="/os/agents" element={<Protected><AgentSetup /></Protected>} />
            <Route path="/os/app/:appId" element={<Protected><AppWorkspace /></Protected>} />
            <Route path="/os/studio/:studioId" element={<Protected><StudioDashboard /></Protected>} />
            <Route path="/os/executive" element={<Protected><ExecutiveDashboard /></Protected>} />
            <Route path="/os/operaciones" element={<Protected><Operaciones /></Protected>} />
            <Route path="/os/operaciones/:id" element={<Protected><OperacionProject /></Protected>} />
            <Route path="/os/metricas-maestras" element={<Gated module="master-metrics"><MasterMetrics /></Gated>} />
            <Route path="/os/automation" element={<Gated module="automation"><Automation /></Gated>} />
            <Route path="/os/intelligence" element={<Gated module="intelligence"><Intelligence /></Gated>} />
            <Route path="/os/assistant" element={<Gated module="assistant"><Assistant /></Gated>} />
            <Route path="/os/academia" element={<Protected><Academy /></Protected>} />
            <Route path="/os/academia/panel" element={<AdminOnly><AcademyDashboard /></AdminOnly>} />
            <Route path="/os/academia/juego/:id" element={<Protected><GamePlayer /></Protected>} />
            <Route path="/os/academia/interactivo/:id" element={<Protected><AuthoredCourse /></Protected>} />
            <Route path="/os/academia/:id" element={<Protected><CourseDetail /></Protected>} />
            <Route path="/os/content-authoring" element={<Protected><ContentAuthoring /></Protected>} />
            <Route path="/os/treasury" element={<Protected><Treasury /></Protected>} />
            <Route path="/os/oracle" element={<Protected><OracleHub /></Protected>} />
            <Route path="/os/analytics" element={<Protected><OmniaAnalytics /></Protected>} />
            <Route path="/os/microsoft" element={<Protected><Microsoft365 /></Protected>} />
            <Route path="/os/facturacion" element={<Protected><Facturacion /></Protected>} />
            <Route path="/os/chat" element={<Protected allowUser><Chat /></Protected>} />
            <Route path="/os/admin" element={<AdminOnly><AdminUsers /></AdminOnly>} />
            <Route path="/os/bitacora" element={<AdminOnly><Bitacora /></AdminOnly>} />
            <Route path="/os/design" element={<AdminOnly><StyleGuide /></AdminOnly>} />
            <Route path="/os/workflows" element={<AdminOnly><Workflows /></AdminOnly>} />
            <Route path="/os/copiloto" element={<Gated module="copiloto"><Copiloto /></Gated>} />
            <Route path="/os/administracion" element={<AdminOnly><Administracion /></AdminOnly>} />
            <Route path="/os/marketplace" element={<Gated module="marketplace"><Marketplace /></Gated>} />
            <Route path="/os/extensiones" element={<AdminOnly><Extensiones /></AdminOnly>} />
            <Route path="/os/integraciones" element={<AdminOnly><Integraciones /></AdminOnly>} />
            <Route path="/os/plataforma" element={<AdminOnly><Plataforma /></AdminOnly>} />
            <Route path="*" element={<CatchAll />} />
          </Routes>
        </BrowserRouter>
        </CartProvider>
        </BrandingProvider>
      </AuthProvider>
      </ThemeProvider>
    </I18nProvider>
  );
}

export default App;
